import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import { OrderingListViewModel, UpdateOrderingListCommand, CreateOrderingListCommand, UserHierarchyViewModel } from "Api/CoreApi";
import store from "Store/index"
import { mixins } from 'vue-class-component';
import UserMixin from 'Mixins/UserMixin';
import BaseComponent from 'Components/Base/ABaseComponent';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';
import Multiselect from 'vue-multiselect';

export class SelectModel{
    id: string;
    name: string;
    obj: OrderingListViewModel;
    $isDisabled: boolean;
}

@Component({
    template: "#ordering-list-selector-template",
    components: {
        Multiselect
    }
})
export default class OrderingListSelectorComponent extends mixins(BaseComponent,OrderingListUserMixin) {
    
    @Prop()
    public disableReloadAfterUpdate: boolean;  
    
    @Prop()
    public limitByPermissionCanViewOrderHistoric: boolean;

    @Prop({ default: false })
    public onlyShowName: boolean;

    public selectedListId: string = null;
    
    public selected: SelectModel = null;
    
    public loadingSetSelected: boolean = false;
    
    async created() {
        
        if(!this.isEmployee) return;
        this.setLoading();
        await store.dispatch.orderingList.loadOrderingLists(false);
        
        const user = store.state.auth.user;
        this.setSelected(user?.extraInfo?.SelectedListId);
        this.setLoaded();
        
    }
    
    setSelected(selectedListId: string) {
        if(!selectedListId || selectedListId === '')
        return;
        
        const selectedList = this.lists.find(x => x.id == selectedListId);
        if(selectedList){
            let newChild: SelectModel = {
                id : selectedList.id,
                name: selectedList.userIsolationKey,
                obj : selectedList,
                $isDisabled: false
            };
            this.selectedListId = selectedList.id;
            this.selected = newChild;
        }
    }
    
    
    get options(): SelectModel[]{
        if(this.lists)
        {
            const dic = new Map<String, String>();
            const list = Array<SelectModel>();
            
            for(let obj of this.lists)
            {
                //limit by permission "canViewOrderHistoric" if prop is enabled
                if(this.limitByPermissionCanViewOrderHistoric && !obj.permissions.canViewOrderHistoric){
                    continue;
                }

                let newChild: SelectModel = {
                    id : obj.id,
                    name: obj.userIsolationKey,
                    obj : obj,
                    $isDisabled: false
                };
                list.push(newChild);
                
                
                
                // if(!dic.has(obj.parentUserIsolationKey))
                // {
                //     let newModel = {
                //         id : obj.parentUserIsolationKey,
                //         name: obj.parentUserIsolationKey,
                //         obj : obj,
                //         $isDisabled: true
                //     };
                //     dic.set(obj.parentUserIsolationKey,obj.parentUserIsolationKey);
                //     list.push(newModel);
                
                //     for(let child of this.lists)
                //     {
                //         if(child.parentUserIsolationKey == obj.parentUserIsolationKey)
                //         {
                //             let newChild: SelectModel = {
                //                 id : obj.userIsolationKey,
                //                 name: obj.userIsolationKey,
                //                 obj : obj,
                //                 $isDisabled: false
                //             };
                //             list.push(newChild);
                //         }
                //     }
                //     return list;
                // }
                
                
            }
            
            return list;
        }
        return <any>[];
    }
    
    customLabel(model: SelectModel): string{
        if(model.$isDisabled){
            return `${model.obj.level} | ${this.customLabelForUser(model.obj.userHierarchy)}`;
        }
        else{
            return `${model.obj.level} | ${this.customLabelForUser(model.obj.userHierarchy)}`;
        }
    }
    
    
    customLabelForUser(obj: UserHierarchyViewModel): string {
        return `${obj.customerNumber.replace('-at-SHOP1','')} (${obj.companyName} : ${obj.customerAddress})`;
    }
    
    get lists(): OrderingListViewModel[] {
        return store.getters.orderingList.orderingLists;
    }
    
    get showlist(){
        return this.lists? this.lists.length > 0 : false; 
    }
    
    onSelect(model: SelectModel)
    {
        this.selectedListId = model.id;
        this.selected = model;
        this.updateScope();
    }
    
    
    async updateScope(){
        
        if(this.selectedListId){

            this.loadingSetSelected = !this.disableReloadAfterUpdate;
            const selectedListInfo = store.state.orderingList.orderingLists.find(x => x.id == this.selectedListId);
            await store.dispatch.orderingList.updateSelectedList(selectedListInfo);
            //ONLY RELOAD IF NOT IN SCOPED AREA (ex. as building lists by parent)
            //dispatch by reloading 
            if(!this.disableReloadAfterUpdate){
                setTimeout(() => {
                    window.location.reload();
                },3)
            }
            // this.loadingSetSelected = false;
        }
    }
    
    
}

Vue.component('ordering-list-selector', OrderingListSelectorComponent);